import React, { useState } from 'react';
import './ContactFormModal.css';
import { sendMessage, getNextVisitorNumber } from '../firebase/dataService';

function ContactFormModal({ onClose }) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [sending, setSending] = useState(false);
  const [status, setStatus] = useState({ type: '', message: '' });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.message.trim()) {
      setStatus({ type: 'error', message: 'الرجاء كتابة رسالتك أولاً' });
      return;
    }
    try {
      setSending(true);
      setStatus({ type: '', message: '' });
      const visitorNumber = await getNextVisitorNumber();
      await sendMessage({
        name: formData.name.trim() || `زائر رقم ${visitorNumber}`,
        email: formData.email.trim() || 'لا يوجد',
        subject: formData.subject,
        message: formData.message
      });
      setStatus({ type: 'success', message: 'تم إرسال رسالتك بنجاح! سنتواصل معك قريباً.' });
      setTimeout(() => onClose(), 2000);
    } catch (error) {
      console.error('Error sending message:', error);
      setStatus({ type: 'error', message: 'فشل إرسال الرسالة. الرجاء المحاولة مرة أخرى.' });
    } finally {
      setSending(false);
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target.className === 'modal-overlay') onClose();
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content">

        <div className="modal-header">
          <div className="modal-header-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
              <polyline points="22,6 12,13 2,6"/>
            </svg>
          </div>
          <div className="modal-header-text">
            <h2 className="modal-title">راسلنا</h2>
            <p className="modal-subtitle">نسعد بتواصلكم واستفساراتكم</p>
          </div>
          <button className="close-button" onClick={onClose} aria-label="إغلاق">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="16" height="16">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>

        {status.message && (
          <div className={`status-message ${status.type}`}>
            {status.type === 'success' ? (
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="18" height="18"><path d="M20 6L9 17l-5-5"/></svg>
            ) : (
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="18" height="18"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            )}
            {status.message}
          </div>
        )}

        <form onSubmit={handleSubmit} className="contact-form">

          <div className="form-row">
            <div className="form-field">
              <label htmlFor="name">
                الاسم
                <span className="field-optional">(اختياري)</span>
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="اسمك..."
              />
            </div>

            <div className="form-field">
              <label htmlFor="email">
                البريد الإلكتروني
                <span className="field-optional">(اختياري)</span>
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="example@email.com"
              />
            </div>
          </div>

          <div className="form-field">
            <label htmlFor="subject">
              الموضوع
              <span className="field-optional">(اختياري)</span>
            </label>
            <input
              type="text"
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              placeholder="موضوع الرسالة..."
            />
          </div>

          <div className="form-field">
            <label htmlFor="message">
              الرسالة
              <span className="field-required">*</span>
            </label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="اكتب رسالتك هنا..."
              rows="5"
              required
            />
          </div>

          <div className="form-actions">
            <button type="button" className="cancel-button" onClick={onClose}>
              إلغاء
            </button>
            <button type="submit" className="submit-button" disabled={sending}>
              {sending ? (
                <>
                  <span className="sending-spinner"></span>
                  جاري الإرسال...
                </>
              ) : (
                <>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="22" y1="2" x2="11" y2="13"/>
                    <polygon points="22 2 15 22 11 13 2 9 22 2"/>
                  </svg>
                  إرسال الرسالة
                </>
              )}
            </button>
          </div>

        </form>
      </div>
    </div>
  );
}

export default ContactFormModal;
